import { c as _c } from "react/compiler-runtime";
import { HEADER_ITEM_API, getHeaderItemPostPath } from 'modules/stores/api/stores-api';
import { HeaderItemUpdateType, HeaderItemViewType } from 'modules/stores/store/content/header/types/header-interface';
import { StoreId } from 'modules/stores/types/stores-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useActions = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post,
      unprocessableContentHandler: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.put,
      unprocessableContentHandler: _temp2
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: putFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] !== postFetcher) {
    t3 = (storeId, data) => postFetcher(getHeaderItemPostPath(storeId), data);
    $[3] = postFetcher;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const createHeader = t3;
  let t4;
  if ($[5] !== putFetcher) {
    t4 = (id, data_0) => putFetcher(`${HEADER_ITEM_API}/${id}`, data_0);
    $[5] = putFetcher;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const updateHeader = t4;
  let t5;
  if ($[7] !== deleteFetcher) {
    t5 = id_0 => deleteFetcher(`${HEADER_ITEM_API}/${id_0}`);
    $[7] = deleteFetcher;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const deleteHeader = t5;
  let t6;
  if ($[9] !== createHeader || $[10] !== deleteHeader || $[11] !== updateHeader) {
    t6 = {
      createHeader,
      updateHeader,
      deleteHeader
    };
    $[9] = createHeader;
    $[10] = deleteHeader;
    $[11] = updateHeader;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(error) {
  throw error;
}
function _temp2(error_0) {
  throw error_0;
}